import { IProductInstallmentsViewConfig } from '../views/product-installments-price/ProductInstallmentsPrice';
import { IShadePickerComponentViewConfig } from '../interfaces/IShadePicker';
import { IProductAutoReplenishOptions } from '../views/product-auto-replenish/ProductAutoReplenish';

export enum ComponentTypes {
    PRODUCT_GRID = 'productGrid',
    PRODUCT_QUICKSHOP = 'productQuickshop',
    PRODUCT_FULL = 'productFull',
    PRODUCT_BRIEF = 'productBrief'
}

export type allowedType =
    | IProductInstallmentsViewConfig
    | IShadePickerComponentViewConfig
    | IProductAutoReplenishOptions
    | undefined;

export type ComponentTypesConfigByType = { [K in ComponentTypes]?: allowedType };
